import { cameraSizes, ImageSizes } from 'components/ui/Avatar/constants';
import { BaseSize, DefaultImage } from 'components/ui/Avatar/types';
import { default as Image, StaticImageData } from 'next/image';

export const getDefaultImage = (
  typeImage: DefaultImage,
  __image: string | StaticImageData,
  size: BaseSize,
) => {
  switch (typeImage) {
    case DefaultImage.Avatar:
      return (
        <Image
          unoptimized
          priority
          src={`/images/avatar/avatar.png`}
          alt={'avatar'}
          width={ImageSizes[size]}
          height={ImageSizes[size]}
        />
      );

    case DefaultImage.Camera:
      return (
        <Image
          unoptimized
          priority
          src={`/icons/${size !== 'small' ? 'medium' : size}Camera.svg`}
          alt={'camera'}
          width={cameraSizes[size]}
          height={cameraSizes[size]}
        />
      );
  }
};
